import { Navigate } from 'react-router-dom';
import { useAdminCheck } from '@/hooks/useAdminCheck';
import { PlaneLoader } from '@/components/PlaneLoader';

interface ProtectedAdminRouteProps {
  children: React.ReactNode;
}

/**
 * Route-level protection for admin routes.
 * Checks admin status BEFORE rendering child components.
 * This provides defense-in-depth alongside RLS policies.
 */
export function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { isAdmin, isLoading } = useAdminCheck();

  // Show loading while checking admin status
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <PlaneLoader />
      </div>
    );
  }

  // Redirect non-admins immediately at route level
  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Only render children if user is verified admin
  return <>{children}</>;
}
